import React from 'react';

/**
 * Generic skeleton loader for data-heavy cards and tables.
 */
export const SkeletonLoader = ({ rows = 3 }) => (
  <div className="skeleton-wrapper" aria-busy="true" aria-live="polite">
    {Array.from({ length: rows }).map((_, index) => (
      <div key={`skeleton-${index}`} className="skeleton-row" />
    ))}
  </div>
);

